<template>
    <el-select 
    size="small" 
    v-model="searcheModel.branch_id" 
    filterable 
    remote 
    :remote-method="remoteMethod" 
    clearable 
    placeholder="请选择" 
    @change="handleChange"
    @visible-change="getList()" 
    :loading="loading">
        <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.leader_name"
            :value="item.id">
        </el-option>
    </el-select>
</template>


<script>
import CommonService from "~/services/common";

export default {
    props: {
        branch_id: {
            required: false,
            default: ''
        },
    },
    data() {
        return {
            list: [],
            searcheModel: {},
            loading: false,
        };
    },

    created() {
        this.resetForm();
    },


    methods: {
        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            //请求侧边栏地区树
            this.getList(params);
        },

        //重置按钮
        resetForm() {
            this.searcheModel = {
                branch_id: this.branch_id,
                name: '',
            };
            this.list = [];
            this.submitSearch();
        },

        getList(params = {}){
            // loading 动画
            this.loading = true;
            CommonService.getBranchLeader(params)
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                console.error(err);
            });
        },

        remoteMethod(query){
            this.searcheModel.name = query;
            this.getList(this.searcheModel);
        },

        handleChange(val){
            this.$emit("change", val);
        },
        
        //对输入框进行重置     
        reset(){
            this.searcheModel = {};
        }           
    }
}
</script>


// WEBPACK FOOTER //
// src/widgets/BranchLeader.vue